import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-star-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/50">
              {siteInfo.tagline}
            </p>
            <p className="text-xs text-background-50/40 mt-3">
              {siteInfo.mission}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/50 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="space-y-3 text-sm text-background-50/50">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-background-50 transition-colors">
                  {siteInfo.email}
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>{siteInfo.phone}</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </p>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteInfo.social.weibo} target="_blank" rel="nofollow" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <span className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" title={`微信：${siteInfo.social.wechat}`}>
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" title={siteInfo.social.douyin}>
                <i className="ri-tiktok-line text-sm"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {siteInfo.foundingYear} - {new Date().getFullYear()} {siteInfo.fullName} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}